import { DefaultState } from 'store/types';
import { RoomGuestReservationData } from 'types/rooms/room-guest';

export const LOCATION_ROOMS_REQUEST = 'LOCATION_ROOMS_REQUEST';
export const LOCATION_ROOMS_SUCCESS = 'LOCATION_ROOMS_SUCCESS';
export const LOCATION_ROOMS_FAILURE = 'LOCATION_ROOMS_FAILURE';

export interface LocationRoomsParams {
  lodgingOptionId: string;
  fromDate: string;
  toDate: string;
};

export interface LocationRoomGuest {
  id: string;
  name: string;
  fromDate: string;
  toDate: string;
  status: string;
  gender: string;
  isFlagged?: boolean;
  reservationData: RoomGuestReservationData;
};

export interface LocationRoomsDataRow {
  bedsAvailable: number;
  bookingId: string | null;
  bookingUserFriendlyId: string | null;
  fromDate: Date;
  toDate: Date;
  guests: LocationRoomGuest[];
  id: string;
  occupancy: number;
  pricePerDayPerBed: number;
  reservationId: string;
  type: string;
  corporateClientName: string;
  reservationProviderId: string;
  reservationProviderName: string;
  providerSendNotification: boolean;
  providerLabelColor: string;
  totalRate: number;
  notesCount: number;
};

export type LocationRoomsData = LocationRoomsDataRow[];

export type LocationRoomsState = DefaultState & {
  contents?: LocationRoomsData;
};

interface LocationRoomsRequest {
  type: typeof LOCATION_ROOMS_REQUEST;
};

interface LocationRoomsSuccess {
  type: typeof LOCATION_ROOMS_SUCCESS,
  contents: LocationRoomsData;
}

interface LocationRoomsFailure {
  type: typeof LOCATION_ROOMS_FAILURE;
}

export type LocationRoomsActionTypes = LocationRoomsRequest | LocationRoomsSuccess | LocationRoomsFailure;